(function ($) {
    $.fn.EquipmentListHandler = function () {
        $(this).click(function (){
            if ($('#equipement-list-modal').find('.waiting').length > 0){

                $.ajax({
                    method: 'GET',
                    url: '/vehicle/get-equipements',
                    success: function (response) {
                        $('#equipement-list-modal').find('.waiting').remove();
                        for( var equipement of response){
                            $('#equipement-list-modal').find('tbody').append(
                                $.parseHTML(
                                    '<tr>'+
                                    '<td class="p-1">'+equipement.poids+'</td>' +
                                    '<td class="p-1">'+equipement.code+'</td>' +
                                    '<td class="p-1">'+equipement.nomCourt+'</td>' +
                                    '<td class="p-1">'+equipement.nomLong+'</td>' +
                                    '</tr>'
                                )
                            );
                        }
                        $('#equipement-list-modal').find('tbody').find('tr')
                            .hover(function () {
                                $(this).addClass('bg-lightblue');
                            },function () {
                                $(this).removeClass('bg-lightblue');
                            })
                            .click(function (){
                                var target = $('#equipement-list-modal').attr('data-target');
                                $('#'+target+'_poids').val($(this).find('td:nth-child(1)').html());
                                $('#'+target+'_nomCourt').val($(this).find('td:nth-child(3)').html());
                                $('#'+target+'_nomLong').val($(this).find('td:nth-child(4)').html());
                                $('#equipement-list-modal').modal('hide');
                            });
                        $('#equipement-list-modal').find('table').DataTable({
                            "paging": false,
                            "autoWidth": false,
                            "info":false,
                            "order":[0, 'desc'],
                            "language": {
                                "url": '../../translations/datatables/dataTables.french.json'
                            }
                        });
                    },
                });
            }

            $('#equipement-list-modal').modal();
            $('#equipement-list-modal').attr('data-target', $(this).attr('data-target'));
        });
    };
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/equipment_list.js